// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__m25d9","content":"RecentSearches_content__1Bhee"};